import { FormControlLabel, Checkbox, FormHelperText, FormControl } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { CampaignInputComponent, CampaignInputComponentProps } from './CampaignInputComponent'
import { FormatVersion } from '~/generated/graphql'
import { z } from 'zod'

export const useRegularlyPublishedCampaignSchemaFields = {
  useRegularlyPublishedCampaign: z.boolean(),
}
export const useRegularlyPublishedCampaignSchema = z.object(useRegularlyPublishedCampaignSchemaFields)

type UseRegularlyPublishedCampaignProps = CampaignInputComponentProps<{
  disabled?: boolean
  disabledReason?: React.ReactNode
}>

export const UseRegularlyPublishedCampaign = ({
  description,
  tooltip,
  disabled = false,
  disabledReason,
}: UseRegularlyPublishedCampaignProps) => {
  const { control } = useFormContext<z.infer<typeof useRegularlyPublishedCampaignSchema>>()

  return (
    <CampaignInputComponent
      title="定期公開設定"
      description={description}
      tooltip={tooltip}
      compatibleFormatVersions={[FormatVersion.V4Campaign]}
    >
      <Controller
        control={control}
        name="useRegularlyPublishedCampaign"
        render={({ field: { ref, ...field } }) => (
          <FormControl>
            <FormControlLabel
              control={<Checkbox {...field} checked={field.value} inputRef={ref} disabled={disabled} />}
              label="次回も同じ内容のキャンペーンを実施しますか？"
              sx={{ width: 'fit-content' }}
            />
            {disabled && disabledReason}
            <FormHelperText sx={{ ml: 0 }}>
              <ul style={{ marginTop: 0 }}>
                <li>
                  本キャンペーンの内容で定期公開したい場合は、チェックを入れてください。
                </li>
                <li>
                  次回以降、自動で公開されるキャンペーンは、インフルエンサー採用が0件の場合、自動で定期公開設定が解除されます。
                </li>
              </ul>
            </FormHelperText>
          </FormControl>
        )}
      />
    </CampaignInputComponent>
  )
}
